<template>
	<div class="chat-content-wrapper">
		<div class="chat-content-container" :class="{active: openAIChatsStore.activeChat && (openAIChatsStore.activeChatId !== 'new' || openAIChatsStore.activeChat?.messages?.length)}">
			<ChatLive :chats="timeChats"/>
			<div class="container-buttons">
				<div @click="redirectToTicket" class="button-description">
					<div class="header-button">
						<img :alt="getString('open_ticket')" :src="'https://img.qromo.io/img/icons/Icon-ticket-outline'+(userStore.darkMode ? '-dark' : '')+'.svg'"/>
						<div class="title-button">
							<p>{{ getString('open_ticket') }}</p>
						</div>
					</div>
					<p class="description">{{ getString('description_button_ticket') }}</p>
				</div>
				<div @click="redirectToHelpDesk" class="button-description">
					<div class="header-button">
						<img :alt="getString('open_ticket')" :src="'https://img.qromo.io/img/icons/Icon-wiky'+(userStore.darkMode ? '-dark' : '')+'.svg'"/>
						<div class="title-button">
							<p>{{ getString('show_wiki') }}</p>
						</div>
					</div>
					<p class="description">{{ getString('description_button_wiky') }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AppButton from "@/shared/components/AppButton.vue";
import {useLanguageStore} from "@/shared/stores";
import {useUserStore, useOpenAIChatsStore} from "@/console-new/stores";
import ChatLive from "@/console-new/components/help/chat/ChatLive.vue";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let openAIChatsStore = useOpenAIChatsStore();
		const timeChats= [
			{
				request: "Request",
				answer: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Et, necessitatibus.",
			}
		];
		return { getString: languageStore.getString, timeChats, openAIChatsStore, userStore};
	},
	name: "ChatSidebar",
	components: { AppButton, ChatLive },
	methods: {
		redirectToHelpDesk() {
			if(this.openAIChatsStore.loadingChats) {
				return
			}
			window.open("https://qromo-help.freshdesk.com/support/home", "_blank");
		},
		redirectToTicket() {
			if(this.openAIChatsStore.loadingChats) {
				return
			}
			window.open("https://qromo-help.freshdesk.com/support/tickets/new", "_blank");
		}
	}
};
</script>

<style scoped lang="scss">
	.chat-content-wrapper {
		display: flex;
		flex-direction: column;
		gap: 20px;
		width: 100%;
		height: 100%;
		justify-content: center;
		align-items: center;
		.chat-content-container {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			gap: 40px;
			height: 100%;
			padding: 10px;
			.container-buttons {
				display: flex;
				width: 100%;
				justify-content: space-between;
				gap: 20px;
				flex-wrap: wrap;
				@media screen and (max-width: 560px) {
					gap: 10px;
				}
				.button-description {
					display: flex;
					flex-direction: column;
					gap: 10px;
					width: calc(50% - 10px);
					padding: 20px;
					background-color: var(--color-bg-primary-1);
					border-radius: 26px;
					cursor: pointer;
					transition: background-color 0.3s $transition;
					@media screen and (max-width: 560px) {
						width: calc(50% - 5px);
						padding: 10px;
						border-radius: 13px;
					}
					@media screen and (max-width: 450px) {
						width: 100%;
						padding: 20px;
						border-radius: 26px;
					}
					.header-button {
						display: flex;
						align-items: center;
						gap: 10px;
						img {
							width: 15px;
							height: 15px;
						}
						.title-button {
							p {
								font-weight: 600;
								font-size: 18px;
								color: var(--color-primary);
								@media screen and (max-width: 560px) {
									font-size: 16px;
								}
							}
						}
					}
					p.description {
						font-weight: 400;
						font-size: 14px;
						color: var(--color-text-2);
						@media screen and (max-width: 560px) {
							font-size: 12px;
						}
					}
					&:hover {
						background-color: var(--color-bg-primary-2);
					}
				}
			}
			&.active {
				.container-buttons {
					display: none;
				}
				&:deep(.container-chat-live) {
					height: 100%;
					.chat-item-list {
						height: 100%;
						display: flex;
					}
					.chat-heading {
						display: none;
					}
				}
			}
		}
	}
</style>